import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (id) => api.get(`/products/${id}`).then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchSizeTable = () => api.get("/size-table").then((r) => r.data);
export const convertSize = (value, unit) =>
  api.post("/convert", { value, unit }).then((r) => r.data);
export const smartMatch = (payload) => api.post("/match", payload).then((r) => r.data);
export const calcConfigurator = (payload) =>
  api.post("/configurator/price", payload).then((r) => r.data);
export const fetchIndustries = () => api.get("/industries").then((r) => r.data);
export const fetchIndustry = (slug) => api.get(`/industries/${slug}`).then((r) => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const fetchOrder = (orderNumber) =>
  api.get(`/orders/${orderNumber}`).then((r) => r.data);
export const sendChat = (sessionId, message) =>
  api.post("/chat", { session_id: sessionId, message }).then((r) => r.data);
